/**
 * Animation properties defined here
 */

export const easing = [0.6, -0.5, 0.01, 0.99];

export const fadeIn = {
  initial: {
    opacity: 0,
    x: 40,
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.2,
      delay: 0.5,
    },
  },
};

export const fadeInLeft = {
  initial: {
    opacity: 0,
    x: 100,
  },
  animate: {
    opacity: 1,
    x: 0,
  },
};

export const fadeInUp = {
  initial: {
    opacity: 0,
    y: 30,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
      easing,
    },
  },
};

export const fadeToggle = {
  fadeIn: {
    opacity: 0,
    height: 0,
    transition: {
      duration: 0.5,
      easing,
    },
  },
  fadeOut: {
    opacity: 1,
    height: 19,
    transition: {
      duration: 0.5,
      easing,
    },
  },
};

export const sizeToggle = {
  smallIn: {
    scale: 1,
    left: 0,
  },
  largeIn: {
    scale: 1.1,
  },
};

export const stagger = {
  animate: {
    transition: {
      staggerChildren: 1.05,
    },
  },
};

export const slideUp = {
  moveUp: {
    rotate: [0, 180],
    transition: {
      easing: 'ease-out',
      duration: 0.3,
    },
  },
  moveDown: {
    rotate: [180, 0],
    transition: {
      easing: 'ease-out',
      duration: 0.3,
    },
  },
};

export const moveCenter = {
  animate: (xCr) => ({
    x: xCr,
    opacity: 1,
    transition: {
      duration: 0.2,
      ease: 'easeOut',
    },
  }),
};

export const accordianAnimation = {
  variants: {
    open: { opacity: 1, height: 'auto' },
    collapsed: { opacity: 0, height: 0 },
  },
  transition: {
    duration: 0.4,
    ease: [0.04, 0.62, 0.23, 0.98],
  },
};
